import React, { useState, useCallback, useEffect } from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import ChangeCardForm from "./ChangeCardForm";

const FORM_NAME = "changeCard";
const selector = formValueSelector(FORM_NAME);

function ChangeCardFormContainer({
  onSubmit,
  loading,
  resetRef,
  requiresCpf,
  showSetAsDefault,
  handleSubmit,
  invalid,
  submitting,
  pristine,
  reset,
  cardNumber,
  holderName,
  goodThru,
  cvv,
}) {
  const [setAsDefault, setSetAsDefault] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const onNewCardSubmit = useCallback(
    (values) => {
      const expiryParts = values.goodThru.split("/");
      const cardData = {
        number: values.creditCard?.number,
        holderName: values.creditCard?.holderName,
        expMonth: parseInt(expiryParts[0], 10),
        expYear: parseInt(`20${expiryParts[1]}`, 10),
        cvv: values.creditCard?.cvv,
        cpf: values.cpf,
        setAsDefault,
        recaptchaToken,
      };

      return onSubmit(cardData);
    },
    [setAsDefault, recaptchaToken, onSubmit],
  );

  const handleFormReset = useCallback(() => {
    reset();
    setSetAsDefault(false);
    setRecaptchaToken(null);
  }, [reset]);

  useEffect(() => {
    if (resetRef) {
      resetRef.current = handleFormReset;
    }
    return () => {
      if (resetRef) resetRef.current = null;
    };
  }, [resetRef, handleFormReset]);

  return (
    <ChangeCardForm
      handleSubmit={handleSubmit(onNewCardSubmit)}
      loading={loading}
      disabled={loading || invalid || submitting || pristine || !recaptchaToken}
      onRecaptchaChange={setRecaptchaToken}
      cardNumber={cardNumber}
      holderName={holderName}
      goodThru={goodThru}
      cvv={cvv}
      onDefaultChange={setSetAsDefault}
      requiresCpf={requiresCpf}
      showSetAsDefault={showSetAsDefault}
    />
  );
}

const mapStateToProps = (state) => ({
  cardNumber: selector(state, "creditCard[number]"),
  holderName: selector(state, "creditCard[holderName]"),
  goodThru: selector(state, "goodThru"),
  cvv: selector(state, "creditCard[cvv]"),
});

export default connect(mapStateToProps)(
  reduxForm({
    form: FORM_NAME,
    destroyOnUnmount: true,
  })(ChangeCardFormContainer),
);
